import { createContext } from "react";

export type DomainFinderContext = [
  boolean,
  React.Dispatch<React.SetStateAction<boolean>>,
];

const domainFinderContext = createContext<DomainFinderContext | null>(null);
export default domainFinderContext;
